import React, { useContext, useState } from "react";
import Modal from "../../../../components/modalWindow/modal";
import { UpdateCardModalProps, UpdateCardModalType } from './types/updateCardModalProps';
import FormField from "../../../../components/formField/formField";
import { FormFieldProps } from "../../../../components/formField/types/formFieldProps";
import ButtonField from "../../../../components/buttonField/buttonField";
import { classNameBtn } from "../../../../components/shared/button/types/buttonProps";
import { ButtonFieldProps } from "../../../../components/buttonField/types/buttonFieldProps";
import ViewContext from "../../../../contexts/viewContext";
import { addProtocol, queryCount } from "../../../../services/arcGisService/arcGisService";
import { apiContext } from "../../../../contexts/apiContext";
import { notifyError, notifySuccess, notifyWarn } from "../../../../components/snackbar/snackbar";
import { ArcGisAddProtocolProps } from "../../../../services/arcGisService/types/arcGisServiceProps";
import { ID_NUMBER } from "../../../../helpers/idNumber";
import { stylizationVerticalAlign } from "../../../../components/shared/stylization";
import './updateCardModal.scss';
import { RegistrationCardIds } from "../../../../services/registrationCardService/types/registrationCardServiceProps";
import { UpdateRegistrationCard, UpdateRegistrationCardSingle } from "../../../../services/registrationCardService/registrationCardService";
import { FiltersTable, SortType, TableContext } from "../../../../contexts/tableContext";
import { ObjectCategories } from "../../administrationView/AdministrationPermissionExtendedView/types/administrationsPermissionExtendedViewProps";
import PermissionsContext from "../../../../contexts/permissionsContext";
import { ColumnType } from "../../../../components/shared/table/types/tableProps";
import UpdateRegistrationCardModal from "../../dataBaseView/updateRegistrationCardModal/updateRegistrationCardModal";

const UpdateCardModal = (props: UpdateCardModalProps) => {
    const { setViewType, viewTypes } = useContext(ViewContext);
    const { extendedUserPermissions } = useContext(PermissionsContext);
    const [value, setValue] = useState('');
    const [objectType, setObjectType] = useState<string>("");
    const api = useContext(apiContext);
    const { setFiltersTableDb, setSortConfigDb } = useContext(TableContext);
    const [loading, setLoading] = useState<boolean>(false);
    const [rowKRUpdate, setrowKRUpdate] = useState<RegistrationCardIds[]>([]);
    const [modalCardUpdate, setmodalCardUpdate] = useState(false);

    const onChangeInput = (event: number) => {
        setValue(event?.toString());
    }

    const getType = () => {
        return objectType === "O" ? "osuwiska" : "terenu zagrożonego";
    }

    var inputProps: FormFieldProps = {
        labelName: `ID ${getType()}`,
        inputPlaceholder: `Podaj ID ${getType()}`,
        style: {
            width: '100%',
            textAlign: 'left'
        },
        type: "number",
        value: value,
        configValidation: {
            required: true
        },
        onlyDigits: true,
        setValue: onChangeInput,
        disabled: loading
    }

    const getBtnProps = (type: string, title: string, permissionDisable: boolean, onClick?: React.MouseEventHandler<HTMLButtonElement>): ButtonFieldProps => {
        let className = classNameBtn.BigSecondary + " body-txt-XL";
        if (objectType === type) {
            className += " BigSecondaryActive";
        }
        return {
            BtnProps: {
                onClick: (e) => {
                    setObjectType(type);
                    if (onClick) onClick(e);
                },
                disabled: permissionDisable ? permissionDisable : loading,
                style: {
                    width: '351px',
                    height: '86px'
                },
                className: className
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign
        };
    }

    const searchInList = () => {
        var filters: FiltersTable[] = [];
        filters = [{
            filterColumnValue: "kr",
            filterColumnName: "RODZAJ_OBIEKTU",
            filterType: ColumnType.Text
        }];
        setFiltersTableDb(filters);
        setSortConfigDb({sortType: SortType.None, filterColumnName: ""});
        setViewType(viewTypes.DataBase);
    }

    const confirm = () => {
        if (value && value != null) {
            checkId();
        } else {
            notifyWarn({ message: `Podaj ID ${getType()}` });
        }
    }

    const callbackUpdateKR = (type: number, rows: any[]) => {
        if(rowKRUpdate && rowKRUpdate.length > 0){
            rowKRUpdate[0].cardPattern = type;
        }
        UpdateRegistrationCard(rowKRUpdate, api.apiUrl, api.apiVersion).then(() => {
            notifySuccess({ message: "Dodano aktualizację karty rejestracyjnej" });
        }).catch((err) => {
            notifyError({ message: "Próba dodania aktualizacji karty rejestracyjnej zakończona niepowodzeniem" });
        })
        .finally(() => {
            setLoading(false);
            setValue('');
        });
        setmodalCardUpdate(false);
    }

    const onCloseModal = () => {
        setmodalCardUpdate(false);
        setLoading(false);
    }

    const checkId = () => {
        const isLandslide = objectType === "O";
        const url = isLandslide ? api.featureServices.landslide : api.featureServices.endangeredArea;
        const where = `${ID_NUMBER}=${value}`;
        const promiseArray = [queryCount({ url: url, where: where })];

        setLoading(true);
        Promise.all(promiseArray).then((values) => {
            const sum = values.reduce((a, b) => a + b, 0);
            
            if (sum === 0) {
                notifyWarn({ message: `W bazie głównej brak ${getType()} o numerze ID: ${value}` });
                setLoading(false);
            } else {
                switch (props.modalType) {
                    case UpdateCardModalType.AddPO: {
                        let arcGisAddProtocolProps: ArcGisAddProtocolProps = {
                            url: url,
                            idNumber: value,
                            isLandslide: isLandslide,
                            where: where,
                            apiBase: api.apiUrl + api.apiVersion
                        }

                        addProtocol(arcGisAddProtocolProps)
                            .then(() => {
                                notifySuccess({ message: "Dodano protokół obserwacji do poczekalni" });
                            })
                            .catch(() => {
                                notifyError({ message: "Próba dodania protokołu obserwacji zakończona niepowodzeniem" });
                            })
                            .finally(() => {
                                setLoading(false);
                            });;
                        break;
                    }
                    case UpdateCardModalType.UpdateKR: {
                        let registationCards: RegistrationCardIds[] = [];

                        UpdateRegistrationCardSingle(registationCards, api.apiUrl, api.apiVersion, where, api.featureServices.dataBase, isLandslide)
                            .then((Ids: RegistrationCardIds[]) => {
                                if(Ids && Ids.length > 0){
                                    setrowKRUpdate(Ids);
                                    var has2007 = false;
                                    var has2020 = false;
                                    var attrs = Ids[0];
                                    if(attrs.cardPattern && attrs.cardPattern === 2007){
                                        has2007 = true;
                                    }
                                    if(attrs.cardPattern && attrs.cardPattern === 2020){
                                        has2020 = true;
                                    }                       
                                    if(!has2007 && has2020){
                                        UpdateRegistrationCard(rowKRUpdate, api.apiUrl, api.apiVersion).then(() => {
                                            notifySuccess({ message: "Dodano aktualizację karty rejestracyjnej" });
                                        }).catch((err) => {
                                            console.log("error:", err);
                                            notifyError({ message: "Próba dodania aktualizacji karty rejestracyjnej zakończona niepowodzeniem" });
                                        }).finally(() => {
                                            setLoading(false);
                                            setValue('');
                                        })
                                    }
                                    else{
                                        setmodalCardUpdate(true);
                                    }
                                }
                                else{
                                    setLoading(false);
                                }
                            })
                            .catch(() => {
                                notifyError({ message: "Próba dodania aktualizacji karty rejestracyjnej zakończona niepowodzeniem" });
                            })
                            .finally(() => {
                                //setLoading(false);
                            });
                        break;
                    }
                };
            }
        }, () => {
            setLoading(false);
            notifyError({ message: "Sprawdzanie podanego ID zakończone niepowodzeniem" });
        });
    }

    const handleClose = () => {
        if (!loading) {
            props.onClose();
        }
    }

    const actionBtns = [
        <ButtonField key={1} placeHolder={props.actionText} BtnProps={{
            onClick: confirm,
            className: `${classNameBtn.Btn} ${classNameBtn.Large} body-txt-medium`,
            disabled: objectType === "" || loading
        }} />
    ]

    const getKRPermissions = (objectCategory: ObjectCategories) => {
        if (extendedUserPermissions.userObjectCategories?.length! > 0) 
            return extendedUserPermissions.userObjectCategories?.includes(objectCategory);
        else return true;
    }

    return (<Modal
        title={props.title}
        titleIcon={props.titleIcon}
        width={'1088px'}
        height={'380px'}
        actionBtns={actionBtns}
        onClose={handleClose}
        loading={loading}>
        <>
            <div className="updateCardBtns">
                <ButtonField {...getBtnProps("O", "Wyszukaj osuwisko", !getKRPermissions(ObjectCategories.Landslide))}></ButtonField>
                <ButtonField {...getBtnProps("TZ", "Wyszukaj teren zagrożony", !getKRPermissions(ObjectCategories.EndangeredArea))}></ButtonField>
                <ButtonField {...getBtnProps("DB", "Wyszukaj obiekt w bazie głównej", false, searchInList)}></ButtonField>
            </div>
            <div>
                {objectType && <FormField {...inputProps} />}
            </div>
        </>
        {modalCardUpdate && <UpdateRegistrationCardModal rowsSignle={rowKRUpdate} callback={callbackUpdateKR} onClose={onCloseModal} />}
    </Modal>);
};

export default UpdateCardModal;